export type CookieType = "essential" | "analytics" | "marketing" | "functional";

export interface CookiePreferences {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
  functional: boolean;
}

const COOKIE_CONSENT_KEY = "cookie-consent";
const COOKIE_PREFERENCES_KEY = "cookie-preferences";

export const getCookieConsent = (): boolean => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(COOKIE_CONSENT_KEY) === "true";
};

export const setCookieConsent = (consented: boolean): void => {
  if (typeof window === "undefined") return;
  localStorage.setItem(COOKIE_CONSENT_KEY, String(consented));
};

export const getCookiePreferences = (): CookiePreferences => {
  if (typeof window === "undefined") {
    return {
      essential: true,
      analytics: false,
      marketing: false,
      functional: false,
    };
  }

  const stored = localStorage.getItem(COOKIE_PREFERENCES_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      // If parsing fails, return defaults
    }
  }

  return {
    essential: true,
    analytics: false,
    marketing: false,
    functional: false,
  };
};

export const setCookiePreferences = (preferences: CookiePreferences): void => {
  if (typeof window === "undefined") return;
  localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(preferences));
};

export const resetCookiePreferences = (): void => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(COOKIE_PREFERENCES_KEY);
  localStorage.removeItem(COOKIE_CONSENT_KEY);
};
